//import { get } from 'lodash';
// import { contentPages as cK } from 'src/tools/contentModulesFieldName';
import arrayMove from 'array-move';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import { useContext } from 'react';
import { EnumFieldType } from 'src/types/common/customerDb';

const useSubscription = () => {
  const {
    tc,
    fields: customerFields,
    buttons,
    animations,
    hoverAnimations,
  } = useContext(ContentModuleGroupPreloadingContext);
  const _f = (customerFields || []).filter(
    (i) => i.fieldType !== EnumFieldType.AreaCodeMobileNumber,
  );
  const handleOnModalConfirm = (value, onChange, data, index) => {
    const _v = (value || []).map((i, _index) => {
      if (_index === index) {
        return { ...i, ...(data || {}) };
      } else {
        return i;
      }
    });
    onChange(_v);
  };

  const handleOnAdd = (value, onChange, data) => {
    //const pc = generateNewContentPage();
    //const { pc } = ;
    onChange([...(value || []), data]);
  };
  const handleOnDelete = (value, onChange, index) => {
    const nValue = (value || []).filter((_, i) => {
      return i !== index;
    });
    onChange(nValue);
  };
  const handleOnSort = (value, onChange, from, to) => {
    const nValue = arrayMove(value || [], from, to);
    onChange(nValue);
  };
  const handleOnTcReselect = (value, onChange, data) => {
    //const nValue = arrayMove(value || [], from, to);
    onChange(data);
  };

  return {
    handleOnModalConfirm,
    handleOnAdd,
    handleOnDelete,
    handleOnSort,
    fieldsOptions: _f,
    buttons,
    animations,
    hoverAnimations,
    tcsOptions: tc,
    handleOnTcReselect,
  };
};
export { useSubscription };
